<div class="mk-card fx">
  <span class="tag">Details for Aivor support</span>
  <pre class="fx-details" #details>{{ text }}</pre>
  <div class="fx-actions">
    <button type="button" class="btn-secondary" (click)="copy()">
      <i class="bi bi-clipboard" aria-hidden="true"></i> Copy the details
    </button>
    <span class="fx-status ok" role="status" *ngIf="copied === 'ok'"><i class="bi bi-check-lg" aria-hidden="true"></i> Copied</span>
    <span class="mk-muted" role="status" *ngIf="copied === 'failed'">Your browser didn't allow copying. The details are selected, so copy them yourself.</span>
  </div>
</div>
